module.exports = __webpack_public_path__ + "static/facebook-bf22a229a69f5a5504ca78511fabf431.png";